import React from 'react';
import { CapaQuotationPartnerStrategy } from '@generated/graphql';

export interface CompanyInfoContextValue {
  partnerId: string;
  partnerInfo?: Omit<CapaQuotationPartnerStrategy, 'email'>;
}

export const CompanyInfoContext = React.createContext<CompanyInfoContextValue | null>(
  null
);

const CompanyInfoContextProvider: React.FunctionComponent<{
  children: React.ReactNode;
  value: CompanyInfoContextValue;
}> = ({ children, value }) => {
  return (
    <CompanyInfoContext.Provider value={value}>
      {children}
    </CompanyInfoContext.Provider>
  );
};

export default CompanyInfoContextProvider;
